<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
	<div id="app">
    <div>
      <vue-headful title="DigiCampus" />
    </div>
		<router-view></router-view>
	</div>
</template>

<script>
import themeConfig from "@/../themeConfig.js";

export default {
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
    '$route'() {
      this.getNewSessionId();
    }
  },
  methods: {
    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    getNewSessionId() {
      if (!sessionStorage.sessionId) {
        var self = this;
        sessionStorage.setItem("sessionId", self.$uuid.v4());
      }
    },
    getValidSubscription(){
      var self = this;
      var onSuccess = response =>{
        localStorage.setItem("subscriptionPermissions",response.data);
        self.$store.dispatch("updateAclSubscription", response.data.split(","))
      }
      self.$ajaxGet(self, `GetSub/Permissions` , onSuccess);
    },
  },
  mounted() {
    this.$setColors();
    this.toggleClassInBody(themeConfig.theme);

    this.getNewSessionId();

    if (window.location.pathname == "/public/dashboard") {
      this.$setCEPSiteInfo();
    } else {
      this.$setSiteInfo();
    }
    if(localStorage.getItem("userInfo")){
      if(this.$getSiteId() == this.$getSiteIdWithContent()){
        this.getValidSubscription();
      }
    }

    var link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = 'https://digicentral.co.za/wp-content/uploads/2020/10/cropped-DigiCentral-Icon-32x32.png';
//     console.log(
//       `
//                  %@@@@@@@@@@@,                                                  
//           /&&@@@@@@@@@@@@@@@@@@@@@&#                                            
//       *%%@@@@@#,,,/%%%%%%*,,,&@@@@@@@@&%%%*                                     
//      %@@@@#/##&@@@@@@@@@@@@@@%###/*(@@@@@@@@@%*                                 
//   ,#@@@&//%@@@@&//////////%@@@@@@@@&/////&@@@@@@@#/*                            
//  ,#@@@#(@@@@#@#(@@@@@@@@@@#**(###@@@@@@@@(*/##&@@@@@@@#**                       
// ,&@@@/#@@@&&@@@@@@@@@@@@@@@@@@@&,,/%%@@@@@@@@@#. (&@@@@@@@#,,                   
// @@@% %@@@,/@@@@@@@@@@@@@@@@@@@@@@@@@@*.*&&@@@@@@@@(..#&@@@@@@@@%.               
// @@@% %@@@,/@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@,   %@@@@@@@@@%  /@@@@@@@@%            
// @@@% %@%. /@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@%   *@@@@@@@@@@/ ..(@@@@@@@&#        
// @@/  %@%  /@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@,   .#@@@@@@@@%    ,&@@@@@@@&*     
// @@/  %@%  /@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@/    ,@@@@@@@@@,   ,#@@@@@@@&/    
// @@/  %@%  /@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@/    ,@@@@@@@@@@/   ,#@@@@@@@@@,  
// @@/  %@%  /@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@%*     *&@@@@@@@@/    .#@@@@@@@@@/ 
// @@/  %@%  /@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@%.     ,@@@@@@@@@@/      %@@@@@@@@/ 
// @@/  %@%  /@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@/       /@@@@@@@@@@@/      %@@@@@@@@@@
// @@/  %@%  /@@@@@@@@@@@@@@@@@@@@@@@@@@@@%         %@@@@@@@@@@@@/      %@@@@@@@@@@
// @@/  %@@@, *@@@@@@@@@@@@@@@@@@@@@@(..         /@@@@@@@@@@@@@@*     ,&@@@@@@@@@@@
// @@/  %@@@,  ,,#@@@@@@@@@@@@@@/,.          *&@@@@@@@@@@@@@@@&,      ,@@@@@@@@@@#/
// @@/  %@@@@/     **********.          /#%@@@@@@@@@@@@@@@@@(.       /@@@@@@@@@@@/ 
// @@/  %@@@@@&/.                 .//%@@@@@@@@@@@@@@@@@@#/*       ./&@@@@@@@@@@@#, 
// @@@% %@@@@@@@@#**        ,***&@@@@@@@@@@@@@@@@@@@%#/         ,#@@@@@@@@@@@@@#.  
// @@@%  /@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@&*          .#@@@@@@@@@@@@@@@/     
// @@@%.  ,&@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@&&/         ..(@@@@@@@@@@@@@@@@@&,      
// @@@@@,    /@@@@@@@@@@@@@@@@@@@@@@@@@@,            /@@@@@@@@@@@@@@@@@@@/         
// @@@@@@/     .%@@@@@@@@@@@@@@@@(...           #&@@@@@@@@@@@@@@@@@@@(             
// @@@@@@@@%.       .,,,,,,,,.            .%%&@@@@@@@@@@@@@@@@@@/,.                
//  %@@@@@@@@&/                     /###@@@@@@@@@@@@@@@@@@@@(*,                    
//   /@@@@@@@@@@@%///,      *////%@@@@@@@@@@@@@@@@@@@@&//,                     
//    .#@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@&##.                      
//       *&@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@&%(                              
//          #@@@@@@@@@@@@@@@@@@@@@@@@@@&&/                                   
//               /@@@@@@@@@@@@@@@@%                                                                                
//       `
//     );
  }
};
</script>

<style lang="scss">
  #app{
    overflow-x: hidden;
  }
   @media only screen and (max-width: 400px){
      .router-view{
        padding: 0 !important;
        padding-inline: 0.25rem !important;
      }
      
   }
</style>
